<script lang="ts">
    export default {
        components: {},
    }
</script>

<template>
    <router-view name="default" />
</template>
